import React from 'react';
import PropTypes from 'prop-types';
import { get } from '../Storage';
import { GridList, GridTile } from 'material-ui/GridList';
import axios from 'axios';
import CasinoGame from '../CasinoGame';
import RaisedButton from 'material-ui/RaisedButton';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TablePromotionCasinoGameListComponent';

var styles = AppSettings.styles;

class PromotionCasinoGameList extends React.Component {

    constructor(props, context) {
        super(props);
        this.state = {
            hasMoreItems: true,
            games: [],
            currentPage: 0
        }
        this.loaderItems = this.loaderItems.bind(this);
    }

    componentDidMount() {
        this.loaderItems();
    }
    loaderItems() {
        var countGames = this.props.data.length;
        var numberForPage = 12;
        var totalPage = Math.ceil(countGames / numberForPage);

        var start = this.state.currentPage * numberForPage;
        var end = start + numberForPage;
        if (end > countGames) {
            end = countGames;
        }
        var games = this.state.games;
        for (var i = start; i < end; i++) {
            var game = this.props.data[i];
            games.push(game);
        }

        var hasMoreItems = true;
        if (this.state.currentPage == totalPage - 1) {
            hasMoreItems = false;
        }
        this.setState(
            {
                games: games,
                hasMoreItems: hasMoreItems,
                currentPage: this.state.currentPage + 1
            }
        );
    }
    render() {
        var games = this.state.games.map(function (game, i) {
            var key = game.GameCode;
            return <CasinoGame key={key} game={game} />

        }.bind(this));

        return (
            <div className="promo-casino-game-list">
                <GridList
                    cellHeight={80}
                    cols={3}>
                    {games}
                </GridList>
                {(() => {
                    if(this.state.hasMoreItems){
                        var label = <span>
                            <i className="fa fa-plus"></i> Altri giochi
                        </span>
                        return( 
                            <RaisedButton
                                onClick={this.loaderItems}
                                label={label}
                                primary={true}
                                style={styles.btnRicarica}
                                fullWidth={true}
                                labelStyle={styles.labelWhite} 
                            />
                        );
                    }
                })()}
            </div>
        );
    }
}

PromotionCasinoGameList.displayName = componentName;

// PropTypes validation
PromotionCasinoGameList.propTypes = {
    data: PropTypes.array.isRequired
};

// default props
PromotionCasinoGameList.defaultProps = {};

PromotionCasinoGameList.contextTypes = {
}

export default PromotionCasinoGameList;